// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-circulations {
  background-color: #000000;
  padding-bottom: 156px;
}

.home-circulations__title {
  color: #FFFFFF;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  margin-bottom: 16px;
}

.home-circulations__container {
  display: flex;
  justify-content: center;
  margin-bottom: 96px;
  gap: 16px;
}

.home-circulations__details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 20px;
}

.home-circulations__detail {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.home-circulations__detail svg {
  margin-bottom: 16px;
}

.home-circulations__detail p {
  color: #FFFFFF;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px;
  margin-bottom: 4px;
}

.home-circulations__detail span {
  color: #7B7B7B;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
}

@media only screen and (max-width: 991px) {
  .home-circulations {
    padding-bottom: 96px;
  }
  .home-circulations__details {
    grid-gap: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/home/components/circulations/Circulations.scss","webpack://./src/modules/home/components/circulations/Circulations.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,qBAAqB;ACCvB;;ADCE;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;ACEvB;;ADCE;EAGE,aAAa;ECIP,uBAAuB;EDA/B,mBAAA;EACE,SAAS;ACEb;;AAEA;EDCE,aAAA;EAEE,2DAAsB;EACtB,cAAa;ACEjB;;ADLG;ECUD,aAAa;EDET,sBAAkB;EAGlB,mBAAkB;ACGxB;;ADlBG;EAmBG,mBAAc;ACGpB;;AAEA;EDDM,cAAa;EACd,eAAA;ECGH,kBAAkB;EDCpB,gBAAkB;EAChB,iBAAA;ECCA,kBDAkB;ACCpB;;AAEA;EACE,cDAG;ECCH,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".home-circulations {\n  background-color: #000000;\n  padding-bottom: 156px;\n\n  &__title {\n    color: #FFFFFF;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-align: center;\n    margin-bottom: 16px;\n  }\n\n  &__container {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 96px;\n    gap: 16px;\n  }\n\n  &__details {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr) );\n    grid-gap: 20px;\n  }\n\n  &__detail {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    svg {\n      margin-bottom: 16px;\n    }\n\n    p {\n      color: #FFFFFF;\n      font-size: 32px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 48px;\n      margin-bottom: 4px;\n    }\n\n    span {\n      color: #7B7B7B;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 30px;\n    }\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .home-circulations {\n    padding-bottom: 96px;\n\n    &__details {\n      grid-gap: 36px;\n    }\n  }\n}",".home-circulations {\n  background-color: #000000;\n  padding-bottom: 156px;\n}\n\n.home-circulations__title {\n  color: #FFFFFF;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.home-circulations__container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-bottom: 96px;\n  gap: 16px;\n}\n\n.home-circulations__details {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: (minmax(250px, 1fr))[auto-fit];\n      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  grid-gap: 20px;\n}\n\n.home-circulations__detail {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.home-circulations__detail svg {\n  margin-bottom: 16px;\n}\n\n.home-circulations__detail p {\n  color: #FFFFFF;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 48px;\n  margin-bottom: 4px;\n}\n\n.home-circulations__detail span {\n  color: #7B7B7B;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 30px;\n}\n\n@media only screen and (max-width: 991px) {\n  .home-circulations {\n    padding-bottom: 96px;\n  }\n  .home-circulations__details {\n    grid-gap: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
